import { CustomSelect } from '@/shared/ui/components';
import type { ICustomSelectProps } from '@/shared/ui';
import { useSearchSelectInput } from './useSearchSelectInput';
import './styles.scss';

export interface ISearchSelectInput extends Omit<ICustomSelectProps, 'options' | 'children'> {
  fetchOptions: (search: string) => Promise<ICustomSelectProps['options']>;
  debounceTimeout?: number;
  isNumberOnly?: boolean;
}

/**
 * Searchable select that loads its device options from the server while the user types. Strips fetchOptions and debounceTimeout out of props and forwards the rest to CustomSelect, wiring fetching, options, searchValue, onSearch and renderNotFoundContent from useSearchSelectInput with client-side filtering disabled.
 *
 * @param props - The remote option fetcher, debounce timeout and any CustomSelect props passed through.
 * @returns The rendered select element.
 */
const SearchSelectInput = (props: ISearchSelectInput) => {
  const { fetchOptions, debounceTimeout, ...restProps } = props;
  const { fetching, options, searchValue, onSearch, renderNotFoundContent } =
    useSearchSelectInput(props);

  return (
    <CustomSelect
      formatDropdownType="deviceId"
      labelInValue
      onSearch={onSearch}
      loading={fetching}
      options={options}
      filterOption={false}
      notFoundContent={renderNotFoundContent()}
      searchValue={searchValue}
      allowClear={false}
      {...restProps}
    />
  );
};

export default SearchSelectInput;
